import { render, staticRenderFns } from "./commuMain.vue?vue&type=template&id=b9a79348"
import script from "./commuMain.vue?vue&type=script&lang=js"
export * from "./commuMain.vue?vue&type=script&lang=js"
import style0 from "./commuMain.vue?vue&type=style&index=0&id=b9a79348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports